module.exports = __webpack_public_path__ + "img/green_edit.463130b1.svg";